export default function Logo() {
  return (
    <div className="flex items-center gap-2.5" data-testid="logo">
      <img
        src="/logo.png"
        alt="Card Cartel"
        className="w-9 h-9 rounded-full object-cover shrink-0"
        style={{ boxShadow: "0 0 18px rgba(212,175,55,0.45)" }}
      />
      <span className="font-display font-bold tracking-[0.18em] text-sm text-[#F4F4F5]">
        CARD <span className="gold-text">CARTEL</span>
      </span>
    </div>
  );
}
